<app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>


<ng-container *ngIf="loadInfo && recordNutritionalPhysicalExamination">
  <p class="text-info mb-sm">Selecciona las enfermedades que padeces o hayas padecido en algún momento.</p>
  <div class="tw-p-5 tw-rounded-md tw-mb-5 tw-border tw-border-solid tw-border-gray-100" *ngFor="let category of categories; index as i">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24">
        <label class="tw-flex tw-items-center">
          <div class="tw-flex tw-items-center">
            <img [src]="'./../../../assets/images/icons/' + category.icon" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">{{ category.name }}</p>
          </div>
        </label>
      </div>
      <nz-collapse nzGhost class="tw-w-full tw-shadow-none">
        <ng-template #header>
          <div class="tw-flex tw-items-center tw-h-4 tw-w-full tw-pr-7">
            <p class="tw-text-gray-900 tw-text-sm truncate">
              Signos relacionados. <span *ngIf="!collapse.nzActive" @fadeInAnimation class="tw-text-gray-600">{{ category.physicalExaminationSigns | stringifyArray: 'symptom' }}</span>
            </p>
          </div>
        </ng-template>
        <nz-collapse-panel
          #collapse
          [nzHeader]="header">
          <p class="text-info tw-ml-4 tw-mt-3">{{ category.physicalExaminationSigns && category.physicalExaminationSigns.length > 0 ? 'Por favor selecciona los signos presentados por el paciente.' : 'No se han establecido signos en la categoría.' }}</p>
          <div nz-col nzXs="24" *ngFor="let sign of category.physicalExaminationSigns; index as j">
            <label nz-checkbox [(ngModel)]="sign.active" [nzDisabled]="disableForm" (ngModelChange)="checkedSignChange($event, sign)">{{ sign.symptom }}</label>
            <p class="tw-text-gray-400">{{ sign.cause }}</p>
          </div>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
  </div>

  <p class="tw-text-xs tw-text-gray-700 tw-mb-4 tw-mt-4">Puedes agregar más información:</p>
    <textarea rows="4" nz-input class="tw-block" placeholder="Agrega más signos detectados al paciente ..." [(ngModel)]="otherSigns"
      [disabled]="disableForm"></textarea>

  <div class="d-flex justify-content-end" *ngIf="!disableForm">
    <button class="mt-xlg" nz-button nzType="primary" (click)="onSave()"><i nz-icon nzType="save" nzTheme="outline"></i>GUARDAR</button>
  </div>
</ng-container>
